import React, { FC } from 'react'
import InlineMessage, { INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { useModal } from 'utils/hooks'
import ShipperCard from '../../../ShipperCard'
import ContactsList from '../../../ShipperContacts/ContactsList/ContactsList'
import { useShipperContactsQuery } from '../../../ShipperContacts/graphql/ShipperContacts'
import { getEdiContacts } from '../../../ShipperContacts/utils/normalizeShipperContacts'
import { EdiContactsModal } from './modals'

export type TEdiContactsModal = 'ediContactsModal'

interface IEdiContactsCardProps {
  shipperId: string
}

const EdiContactsCard: FC<IEdiContactsCardProps> = ({ shipperId }) => {
  const { closeModal, isOpen, openModal } = useModal<TEdiContactsModal>()

  const { data, error, loading } = useShipperContactsQuery({
    variables: {
      shipperId,
    },
    // TODO: SOP-1496 Remove fetch policy when the overview and billing contacts modals are updated to use graphql
    fetchPolicy: 'network-only',
    skip: !shipperId,
  })

  const { contacts } = data?.shipperApplication || {}

  const ediContacts = getEdiContacts(contacts)
  const errorMessage = error?.message || 'There was an error fetching contacts'
  const noContactsMessage = 'There are no EDI contacts.'

  return (
    <div>
      {isOpen('ediContactsModal') && (
        <EdiContactsModal contacts={contacts} onClose={closeModal} open />
      )}
      <ShipperCard
        title='EDI Contacts'
        editable
        onEdit={openModal('ediContactsModal')}
        loading={loading}>
        {error ? (
          <InlineMessage message={errorMessage} type={INLINE_MESSAGE_VARIANTS.ALERT} />
        ) : (
          <ContactsList contacts={ediContacts} noContactsMessage={noContactsMessage} />
        )}
      </ShipperCard>
    </div>
  )
}

export default EdiContactsCard
